module.exports = __webpack_public_path__ + "static/vue-theme-vuemail-848392fd172ce3eda6cacbc88670c061.jpg";